import { useMutation, UseMutationResult } from '@tanstack/react-query';
import CsReviewApi from '../../../../../../lib/api/cs/review/CsReviewApi';
import { TagsExcelUploadResponseBodyDto } from '../../types/TagListTypes';
import { setUploadFile } from '../../util/util';
import { COMMON_RES_CODE } from '../../../../../../constants/responseCode/commonResCode';
import toastMsg from '../../../../../../lib/toastMsg';

const useTagExcelUpload = (): UseMutationResult<TagsExcelUploadResponseBodyDto, unknown, File, unknown> => {
  return useMutation((file: File) => CsReviewApi.setCsReviewDetailTagExcelUpload(setUploadFile({ attachment: file })), {
    onSuccess: (data: TagsExcelUploadResponseBodyDto) => {
      // 업로드가 성공하지 못 했을 경우, 에러 처리
      if (data.status !== COMMON_RES_CODE.SUCCESS && data.msg) {
        toastMsg.error(data.msg);
      }
    },
  });
};

export default useTagExcelUpload;
